import React from 'react';
import { NavLink } from 'react-router-dom';
import Spinner from '../../Component/Spinner/Spinner';
import { useQuery } from 'react-query';


const Sidebar = () => {
    const { data: categories = [], isLoading, refetch } = useQuery({
        queryKey: ["categories"],
        queryFn: async () => {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/category`
            );
            const data = await res.json();

            if (data.success) {
                isLoading(false)
                refetch();
                return data.data;
            } else {
                return [];
            }
        },
    });

    if (isLoading === true) {
        return <Spinner />;
    }
    return (
        <div className="w-64 border border-gray-300 rounded-md overflow-hidden bg-white dark:bg-gray-900 dark:border-gray-700">
            <div className="bg-blue-700 w-full">
                <h2 className="text-xl font-semibold text-white px-5 py-2">
                    Filter Ads
                </h2>
            </div>
            <div>
                <h2 className="text-md font-bold text-gray-700 dark:text-gray-200 px-5 py-2">
                    Categories
                </h2>

                <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700" />

                <div className="px-5 py-2 ml-2">
                    <ul>
                        {categories?.map((category) => (
                            <li key={category?._id}>
                                <NavLink
                                    to={`/category/${category._id}`}
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-blue-700 font-bold before:content-['•'] before:mr-1 before:blue-red-500"
                                            : "text-gray-700 dark:text-gray-400 font-normal"
                                    }
                                >
                                    {category.categoryName}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;